import React, { Component } from "react";
import { Globals } from "../constants";

import { Helmet } from "react-helmet";

class FantasyView extends Component {
  constructor(props) {
    super(props);
    let user = JSON.parse(localStorage.getItem("user"));
    this.xAccessToken = user ? user.xAccessToken : "";
    this.xAccessToken = window.btoa(this.xAccessToken); // bas64 encoding
    this.msisdn = user ? user.phone : "";
  

    this.fantasyVerificationURL =
      Globals.telco === "mobilink"
        ? "https://jazz-fantasy.cricwick.net/authentication/"
        : "https://fantasy.cricwick.net/authentication/"; // live          testcricket.s3-website-us-east-1.amazonaws.com

    
        
    if (user) {
      this.fantasyVerificationURL = `${this.fantasyVerificationURL}${
        this.xAccessToken
      }/${this.msisdn}/${user.inviteCode}/${window.location.search}${
        window.location.search.length ? "&" : "?"
      }domain=${
        Globals.telco !== "mobilink" ? "cricwick" : "jazzcricket"
      }#utm_source=${Globals.appName}&utm_medium=web&utm_campaign=MyStars11`;
    } else {
      this.fantasyVerificationURL = `https://fantasy.cricwick.net/free-authentication/${window.location.search}${
        window.location.search.length ? "&" : "?"
      }domain=${
        Globals.telco !== "mobilink" ? "cricwick" : "jazzcricket"
      }#utm_source=${Globals.appName}&utm_medium=web&utm_campaign=MyStars11`;
    }

    
  }

  render() {
    return  (
      <div
        id="main-section"
        className="holds-the-iframe"
        style={{ backgroundColor: "#FFFFFF", zIndex: "0" }}
      >
        <Helmet>
          <title>
            Play Fantasy League for free and Win Exciting Cash Prizes -
            {Globals.product}
          </title>
          <meta
            name="description"
            content={
              "Play Fantasy League for free. Create your team today, beat the competition and win exciting cash prizes on MyStars11, only on " +
              Globals.product
            }
          />
        </Helmet>
        <iframe
          title="fantasy"
          src={this.fantasyVerificationURL}
          style={{ width: "100%", height: "1080px" }}
          frameBorder="0"
        />
      </div>
    )
  }
}

export default FantasyView;
